<template>
  <div>
    <component
      :is="panelconfig.panel + 'Config'"
      v-if="panelconfig.panel !== undefined"
      v-bind="{panelconfig: panelconfig, }"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue'
// Statistics
import StatisticCardHorizontal from '../Panels/Statistics/StatisticCardHorizontal.vue'
import StatisticCardHorizontalConfig from '../Panels/Statistics/StatisticCardHorizontalConfig.vue'

import StatisticCardVertical from '../Panels/Statistics/StatisticCardVertical/StatisticCardVertical.vue'
import StatisticCardVerticalConfig from '../Panels/Statistics/StatisticCardVertical/StatisticCardVerticalConfig.vue'

import StatisticCardWithAreaChart from '../Panels/Statistics/StatisticCardWithAreaChart/StatisticCardWithAreaChart.vue'
import StatisticCardWithAreaChartConfig from '../Panels/Statistics/StatisticCardWithAreaChart/StatisticCardWithAreaChartConfig.vue'

// Analytics
import Chart from '../Panels/Analytics/LineChart/LineChart.vue'
import ChartConfig from '../Panels/Analytics/LineChart/LineChartConfig.vue'
import BarChart from '../Panels/Analytics/BarChart/BarChart.vue'
import BarChartConfig from '../Panels/Analytics/BarChart/BarChartConfig.vue'

export default {
  components: {
    BRow,
    BCol,
    StatisticCardHorizontal,
    StatisticCardHorizontalConfig,
    StatisticCardVertical,
    StatisticCardVerticalConfig,
    StatisticCardWithAreaChart,
    StatisticCardWithAreaChartConfig,
    Chart,
    ChartConfig,
    BarChart,
    BarChartConfig,
  },
  props: {
    panelconfig: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style>

</style>
